// extracted by css-extract-rspack-plugin
export default {"cls1":"FriendlySutdModal-cls1_ybk","cls2":"FriendlySutdModal-cls2_MqS FriendlySutdModal-cls1_ybk"};